import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'editor-view',
  templateUrl: './editor-view.component.html',
  styleUrls: ['./editor-view.component.scss'],
})
export class EditorViewComponent implements OnInit {

  @Input() public activeEmployeeGroupes: number[] = []
  @Input() public activeObserverEmployeeGroupes: number[] = []
  @Input() public activeEmployees: number[] = []
  @Input() public activeObserverEmployee: number[] = []

  @Output() public addEmployee: EventEmitter<any> = new EventEmitter<any>(null)

  constructor() { }

  ngOnInit() {}

}
